import React, {PureComponent} from 'react'
import './News.css'

class News1 extends PureComponent {
	render() {
		return (
			<div style={{maxWidth: '667px', margin: 'auto'}}>
				<div id="img-content">
					<h2 className="rich_media_title" id="activity-name">
						世界性“中餐厨师荒”荒了7年，业界提出了新的解决办法！
					</h2>
					<div className="rich_media_content" id="js_content">
						<section style={{
							letterSpacing: '0px',
							paddingRight: '6px',
							paddingLeft: '6px',
							fontSize: '16px',
							lineHeight: 2,
							boxSizing: 'border-box'
						}}>
							<section>
								<p>
									<span style={{fontSize: '16px'}}>“厨师荒”荒了多少年？</span>
								</p>
								<p>
									<span style={{fontSize: '16px'}}>我们来理理时间线。</span>
								</p>
								<p>
									<br/>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.1.webp"/>
							</section>
							<section>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2011年</strong>，英国正式宣布从“短缺工种名单”(Shortage Occupation List)剔除八个工种，但厨师仍保留在短缺名单上。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.2.webp"/>
							</section>
							<section>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2012年</strong>，海外还在跟移民法较劲。</span>
								</p>
								<p>
									<span
										style={{fontSize: '16px'}}>严苛的移民法限制中餐人才海外输送——麒麟中餐厅2012年大放异彩，但据称当局对移民劳工的相关政策调整，把这家中餐馆的前途置于了危险境地。实施新的移民法之后，这些中国厨房工必须要提高他们的语言技能才能获得来澳的临时劳工签证。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.3.webp"/>
							</section>
							<section>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;
										<strong>2013年</strong>，即使签证发放最多，厨师的缺口依然很大——</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.4.webp"/>
							</section>
							<section>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2014年</strong>，海外商会不断呼吁政策变革引进更多的中餐人才——</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.5.webp"/>
							</section>
							<section>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2015年</strong>，美国的情况也好不哪儿去。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.6.webp"/>
							</section>
							<section>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2016年</strong>，国内的状况也并不乐观，节前出现用工荒。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.7.webp"/>
							</section>
							<section>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2017年</strong>，饭店“年夜饭”预订火爆，这个特殊的日子里，厨师“荒了”。</span>
								</p>
								<p>
									<span>
										&nbsp;&nbsp;&nbsp;&nbsp;据小编了解，年底餐饮业“用工荒”已经成了普遍现象，不光是中小饭店用工紧缺，很多星级大酒店和大型连锁餐饮企业也缺人，其中又以厨师的招聘需求最为迫切。
									</span>
								</p>
								<p>
									<span>
										&nbsp;&nbsp;&nbsp;&nbsp;“为确保年底正常经营，餐饮业不仅提前招人，还纷纷提高年底厨师的薪资，预计春节期间部分留岗厨师日薪最高将突破千元。”
									</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.8.webp"/>
							</section>
							<section>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;<strong>2018年</strong>，目前还没过完，“厨师荒”的新闻已经出现在各大媒体上了。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F19.jpeg"/>
							</section>
							<section>
								<div className='text-center' style={{fontSize: '12px'}}>
									这都抱在一起哭第几次了。。。
								</div>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;海外中餐从业人员用工荒的现象很大一部分原因是移民困难。各国的移民新政策非常苛刻。</span>
								</p>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;那么，有没有什么办法可以<strong>绕过移民</strong>这个老大难的问题，让中华美食走向世界，造福海外的中国胃？</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.9.webp"/>
							</section>
							<section>
								<div className='text-center' style={{fontSize: '12px'}}>
									好想法
								</div>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;美未的忠实读者您肯定知道。一个海外空中课堂的平台——“海外空中烹饪课堂”已经搭建完成。</span>
								</p>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;上一篇文章提到，海外空中课堂第一期课程共有446个享有知识产权的高清中餐烹饪教学视频目前已全部在美未海外传播平台上线。</span>
								</p>
								<p><br/></p>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;第一期有什么内容呢？</span>
								</p>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;先来感受一波图。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.10.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.11.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.12.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.13.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.14.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.15.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.16.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.17.webp"/>
							</section>
							<section>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;第一期视频中，主要有中式面点工艺、烹调工艺、冷菜工艺、食品雕刻工艺、饮食风俗、宴会设计、厨政管理与实务等<strong>8大部分</strong>专业内容共美未屏使用者学习。</span>
								</p>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;在这<strong>446</strong>个视频里，<strong>8</strong>大菜系基本全了。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.18.webp"/>
							</section>
							<div className='text-center' style={{fontSize: '12px'}}>
								杭州酱鸭
							</div>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.19.webp"/>
							</section>
							<div className='text-center' style={{fontSize: '12px'}}>
								水晶虾饺
							</div>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.20.webp"/>
							</section>
							<div className='text-center' style={{fontSize: '12px'}}>
								拔丝金橘
							</div>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.21.webp"/>
							</section>
							<div className='text-center' style={{fontSize: '12px'}}>
								臭桂鱼
							</div>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.22.webp"/>
							</section>
							<div className='text-center' style={{fontSize: '12px'}}>
								东坡肘子
							</div>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F3.23.webp"/>
							</section>
							<div className='text-center' style={{fontSize: '12px'}}>
								灌汤包
							</div>
							<p>
								<span style={{fontSize: '14px'}}>（编辑完这组图，小编口水流了一地。。。）</span>
							</p>
							<p>
								<span
									style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;也就是说，这些视频全部投放在了空中课堂平台上，海外中餐馆的老板们可以通过美未屏幕登陆到空中课堂平台——然后就可以免费学习以上视频啦。</span>
							</p>
							<p>
								<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;在此感谢视频的提供者是浙江商业职业技术学院。</span>
							</p>
							<p>
								<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;最后，欢迎各位美未屏幕的用户观看视频，为中餐的海外版图添砖加瓦~</span>
							</p>
							<p><br/></p>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

export default News1


// WEBPACK FOOTER //
// ./src/News3.js